module.exports = __webpack_public_path__ + "img/no-sensor-ship.67d828db.svg";